import { concatStatic } from '../operator/concat';

export const concat = concatStatic;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/concat.ts